module.exports = __webpack_public_path__ + "static/media/geometric-alt-new.7f6b2372.png";